import Vue from 'vue';
import SearchPageView from '@/js/desktop/View/SearchPage';
import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import FiltersSerp from '@ve/components/searchFilters/filterList/desktop/FiltersSerp.vue';
import commonCategoriesList from '@ve/components/filters/hotelCategoriesFilter/common/commonCategoiesList';

@extendDecorator({
    events: {
        'click .show-all-country': 'showAllHotDeal',
    },
})
export default class SearchPageHotView extends SearchPageView {
    showAllHotDeal(e) {
        e.preventDefault();
        e.stopPropagation();
        this.model.set('showOtherCountry', true);
    }

    getModelOptions({ searchFormViewModel }, hotelsCollection, filterCriteria) {
        return {
            filterCriteria,
            hotelsCollection,
            searchFormViewModel,
            showOtherCountry: false,
            sortStrategy: 'priceUp',
        };
    }

    initFiltersComponent(store) {
        return new Vue({
            name: 'FiltersListSerp',
            render: (h) => h(FiltersSerp, {
                props: {
                    categoriesList: commonCategoriesList,
                    resortVisible: false,
                    directFlightVisible: false,
                },
            }),
            store,
        }).$mount('.filters-list-serp');
    }
}
